module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-1-a5414d5df478db6164a4587cb221dc07.jpg";